import React, { useEffect, useRef, useState } from 'react';
import { postService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import { edmDto, PostDto } from '../../../api/interfaces/Posts';
import Pagination from '../../Portals/usersMangmnt/Pagination';
import { useLoader } from '../../../Loader/LoaderContext';
import { useNavigate } from 'react-router-dom';
import { useToaster } from '../../../Toaster/Toaster';
type FilterType = {
  role: string[];
  status: string[];
  leads:string[];
  addedByLeads:number[];
  assignedTo:number[];
  statusInPosts:string[];
  serviceFilterInPosts:string[];
  featuredTypeFilter:string[];
  postType:string[];
  pitchedBy:number[],
  country:number[],
  types:string[],
  companyType:string[],
  allPost:string[],
  allEvents:string[],
  allExpiredEvents:string[]
};
interface LeadsTableProps {
  leads: PostDto[]; // Use DTO for leads prop
}
const EmailMarketing: React.FC = () => {
  
type SortType = {
  column: string;
  direction: number;
};
interface VehicleContent {
  status: string;
  // add other fields that exist in the objects inside content, e.g., id, title, etc.
} 
  const { showToast } = useToaster();
 const [tableData ,setTableData] =useState([]);
 const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalElement,setTotalElements] = useState(0);
  const [filters, setFilters] = useState<FilterType>({ role: [], status: [] ,leads:[],addedByLeads:[],assignedTo:[],statusInPosts:[],serviceFilterInPosts:[],featuredTypeFilter:[],postType:[],pitchedBy:[],country:[],types:[],companyType:[],allPost:[],allEvents:[],allExpiredEvents:[]});
  const {setLoading} =useLoader();
  const navigate =useNavigate();
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const toggleDropdown = (index: number) => {
    setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
  };
 const dropdownRef = useRef<HTMLDivElement | null>(null);

const addPost=()=>{
  
  navigate('/vendorDashboard/activateDashboard/emailMarketing/createContent')
}
  useEffect(() => {
    setFilters({
      role: [],
      status: [],
      leads: [],
      addedByLeads: [],
      assignedTo: [],
      statusInPosts: [],
      serviceFilterInPosts: [],
      featuredTypeFilter: [],
      postType: [],
      pitchedBy: [],
      country: [],
      types: [],
      companyType: [],
      allPost:[],
      allEvents:[],
      allExpiredEvents:[]
    });
    fetchVehicles();
  }, []);
const fetchVehicles = async () => {
  setLoading(true);
  let leadID=localStorage.getItem('vendorId')
  let body:any;
     body={
      page:currentPage,
      search:searchQuery,
      vendorId:leadID
    }
  try {
    let url:any;
    const response = await postService(API_ENDPOINTS.getEdms,body);
    setTableData(response.data.content);
    setTotalPages(response.data.totalPages);
    setTotalElements(response.data.totalElements);
    setTimeout(() => {
      setLoading(false)
    }, 1000);
  } catch (error) {
    showToast('error', 'error','');
    console.error('Error fetching vehicle data:', error);
    setTimeout(() => {
      setLoading(false)
    }, 1000);
  }
  finally{
   
  }
};  
const onPageChange = async (page: number) => {
  setCurrentPage(page)
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };
const handleEdit = (data: any) => {
  navigate('/vendorDashboard/activateDashbord/emailMarketing/createContent?appUserId=' + data?.id);
};

const [sort, setSort] = useState<SortType>({ column: '', direction: 1 });
const handleSort = (column: string) => {
  const direction = sort.column === column && sort.direction == 1 ? 0 : 1;
  setSort({ column, direction });
};
const view=(data:any)=>{
  navigate('/vendorDashboard/activateDashbord/emailMarketing/viewData?appUserId='+data?.id)
}
  return (
    <div className="h-full py-2 w-full relative md:px-8">
      <div className='py-4'>
      
      </div>
      <div className='flex items-center mb-3 mt-2 cursor-pointer justify-between'>
        <div className='flex items-center'>
        <>
        <h1 className="text-2xl font-bold mb-2 text-[#2D2E2F] mr-3">
        EDMs
        </h1>
        
        </>
        </div>
        <div className='flex items-center '>
          {userInfo?.roles ==="publisher" &&
        <div className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4' onClick={addPost}><span className='mr-2'></span>Upload HTML</div>
          }
        </div>
      </div>
     
      {/* <div className="overflow-x-auto scroolCls">
      <table className="min-w-full bg-white border border-gray-200 w-full">
  <thead className="bg-gray-100 text-left">
    <tr>
      <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs left-0 bg-gray-100 z-20 w-[50px]">
        #
      </th>
      <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs w-[250px]">
        Subject
      </th>
      <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs flex items-center">
        <span className="text-gray-600 font-semibold text-xs flex items-center cursor-pointer" onClick={() => handleSort('addedDate')}>Execution Date 
            <img
      className={`ml-2 transform transition-transform duration-300 ${
        sort.column === 'addedDate' && sort.direction === 1 ? 'rotate-180' : ''
      }`}
      src='/images/sortArrow.svg'
    /></span></th>
     
     <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs w-[250px] text-right">
       
        <span className="text-gray-600 font-semibold text-xs flex items-center cursor-pointer" onClick={() => handleSort('uploadDate')}> Upload Date
            <img
      className={`ml-2 transform transition-transform duration-300 ${
        sort.column === 'uploadDate' && sort.direction === 1 ? 'rotate-180' : ''
      }`}
      src='/images/sortArrow.svg'
    /></span>
      </th>
    </tr>
  </thead>
  <tbody>
    {tableData.map((user: edmDto, index: number) => (
      <tr key={index}>
        <td className="px-4 py-3 border-b text-sm text-gray-900 left-0 bg-white font-semibold z-10 cursor-pointer w-[50px] whitespace-nowrap" onClick={()=>view(user)}>
          {user?.uuid || 'NA'}
        </td>
        <td className="px-4 py-3 border-b text-sm text-gray-800 bg-white font-medium cursor-pointer w-[100%] line-clamp-1 whitespace-nowrap">
  {user?.subject ||'NA'}
</td>

        <td className="px-4 py-3 border-b text-sm text-gray-500 bg-white font-normal cursor-pointer w-[150px] whitespace-nowrap">
          {user?.date || 'NA'}
        </td>
        <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap text-right">
                    <div className="flex justify-between items-center">
                      <span  className="cursor-pointer">
                       {user?.addedDate || 'NA'}
                      </span>
                      {(userInfo?.roles ==='PUBLISHER') &&
                             <img
                               src="/images/threeDot.svg"
                               alt="Menu1"
                               className="cursor-pointer ml-5"
                               onClick={() => toggleDropdown(index)}
                             />
                       }
                            {activeDropdown === index && userInfo?.roles !== 'PUBLISHER'  && (
                               <div ref={dropdownRef} className="absolute right-[22px] mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10 ==">
                                 <div className="py-2">
                                 
                                    <span className='flex px-4 cursor-pointer' onClick={() => handleEdit(user)}>
                                      <img src='/images/editIcon.svg' alt="Edit" />
                                      <a href="#" className="ml-2 block py-2 text-sm text-[#374151] font-normal">
                                        Edit
                                      </a>
                                    </span>
                                
                                  
                                  
                                 </div>
                               </div>
                             )}
                    </div>
                  </td>
      </tr>
    ))}
  </tbody>
</table>


  {!tableData.length && <p className="text-center p-2 bg-white">Your data will appear here once added.</p>}

  {totalPages > 1 && (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      totalElement={totalElement}
      onPageChange={onPageChange}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  )}
</div> */}
<div className="overflow-x-auto scroolCls">
      <table className="min-w-full bg-white border border-gray-200 w-full">

      <thead className="bg-gray-100 text-left">
        <tr>
          <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky left-0 bg-gray-100 z-20 w-[50px]">
            #
          </th>
          <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs w-[250px]">
           Subject
          </th>
          <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs w-[250px]">
          <span className="text-gray-600 font-semibold text-xs flex items-center cursor-pointer" onClick={() => handleSort('addedDate')}>Execution Date 
             <img
       className={`ml-2 transform transition-transform duration-300 ${
         sort.column === 'addedDate' && sort.direction === 1 ? 'rotate-180' : ''
       }`}
       src='/images/sortArrow.svg'
     /></span>
          </th>
       

           <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs flex items-center">
          <span className="text-gray-600 font-semibold text-xs flex items-center cursor-pointer" onClick={() => handleSort('uploadDate')}>Upload Date
             <img
       className={`ml-2 transform transition-transform duration-300 ${
         sort.column === 'uploadDate' && sort.direction === 1 ? 'rotate-180' : ''
       }`}
       src='/images/sortArrow.svg'
     /></span></th>
          
      
        </tr>
      </thead>
      <tbody>
        {tableData.map((user: edmDto, index: number) => (
          <tr key={index}>
            <td className="px-4 py-3 border-b text-sm text-gray-900 sticky left-0 bg-white font-semibold z-10 cursor-pointer w-[50px] whitespace-nowrap" onClick={()=>view(user)}>
              {user?.uuid || 'NA'}
            </td>
            <td className="px-4 py-3 border-b text-sm text-gray-800 font-medium line-clamp-1">
  <div className="flex justify-between items-center">
    <span className="cursor-pointer line-clamp-1">
      {user?.subject || 'NA'}
    </span>
   
  </div>
</td>
<td className="px-4 py-3 border-b text-sm text-gray-500 bg-white font-normal cursor-pointer whitespace-nowrap w-[100px]">
      {user?.date || 'NA'}
    </td>
    <td className="px-4 py-3 border-b text-sm text-gray-500 bg-white font-normal cursor-pointer whitespace-nowrap w-[100px]">
      
      <div className="flex justify-between items-center">
    <span className="cursor-pointer line-clamp-1">
    {user?.addedDate || 'NA'}
    </span>
    {/* {
      userInfo?.roles ==='PUBLISHER' &&
    <img
      src="/images/threeDot.svg"
      alt="Menu1"
      className="cursor-pointer ml-5"
      onClick={() => toggleDropdown(index)}
    />}
     {activeDropdown === index   && (
                                <div ref={dropdownRef} className="absolute right-[22px] mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10 ==">
                                  <div className="py-2">
                                   
                                     <span className='flex px-4 cursor-pointer' onClick={() => handleEdit(user)}>
                                       <img src='/images/editIcon.svg' alt="Edit" />
                                       <a href="#" className="ml-2 block py-2 text-sm text-[#374151] font-normal">
                                         Edit
                                       </a>
                                     </span>
                                  </div>
                                </div>
                              )} */}
  </div>
    </td>

          </tr>
        ))}
      </tbody>
    </table>

  {!tableData.length && <p className="text-center p-2 bg-white">Your data will appear here once added.</p>}

  {totalPages > 1 && (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      totalElement={totalElement}
      onPageChange={onPageChange}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  )}
</div>
      
        </div>
        
  );
};
export default EmailMarketing
